import { Box, Card, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { StyledComponent } from 'src/components/styled-components/styledComponent';
import HttpServices from 'src/services/httpService';
import { postsModuleURL } from 'src/services/urlService';
import { CommonHelper } from 'src/utils/commonHelper';
import Spinner from 'src/utils/Loader/spinner';
import { useToaster } from 'src/utils/toaster/toasterContext';
import DraftsPostGrid from './Grid/PostGrid.component';
import { DemoHelper } from 'src/utils/demoUtil/demoUtil';


const Draft = () => {
  const { t: translate } = useTranslation();
  const [draftList, setDraftList] = useState([]);
  const [order, setOrder] = useState();
  const [orderBy, setOrderBy] = useState();
  const { showToast } = useToaster();
  const [loader, setLoader] = useState(true);
  const [isOrgEvent, setOrgEvent] = useState(CommonHelper.GetIsOrgLevelEvent());
  const hasOrgAdminPermission = CommonHelper.CheckForPermissionAvailableForUser(CommonHelper.PermissionList.ORG_ADMIN);
  const isShowOfferBanner = CommonHelper.ShowOfferBanner();

  useEffect(() => {
    getDraftList('created_time', 'desc');
  }, [isOrgEvent]);

  const draftSuccessCallback = (data, message) => {
    setLoader(false);
    let filteredData = data.filter((data) => data.connected_profile_details?.length > 0);
    setDraftList(filteredData);
  };
  const draftFailureCallback = (message) => {
    setLoader(false);
    message && showToast(message, 'e');
  };

  const getDraftList = (sortBy = '', sortOrder = '') => {
    setOrder(sortOrder);
    setOrderBy(sortBy);
    let currentDate = new Date();
    let tDate = currentDate.setDate(currentDate.getDate() + 365);
    currentDate.setHours(0, 0, 0, 0);
    tDate = new Date(currentDate).toISOString();
    let getProps = {
      url: `${
        isOrgEvent ? postsModuleURL.orgLoadDraft : postsModuleURL.loadDraft
      }?sort_by=${sortBy}&sort_order=${sortOrder}`,
      successCallback: draftSuccessCallback,
      failureCallback: draftFailureCallback,
    };
    HttpServices.Get(getProps);
  };
  const handleReCallDraft = (sortBy = '', sortOrder = '') => {
    setLoader(true);
    getDraftList(sortBy, sortOrder);
  };
  const handleOrgConnectedProfiles = (event) => {
    const checked = event.target.checked;
    setOrgEvent(checked);
    CommonHelper.SetIsOrgLevelEvent(checked);
  };

  return (
    <>
      <Helmet>
        <title>{translate('navbar.menu.draft')}</title>
      </Helmet>
      <Box>
        {loader ? (
          <Spinner />
        ) : (
          <>
            {hasOrgAdminPermission && !DemoHelper.IsDemoAccount() &&(
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 1,
                  mb: 1, // add bottom margin for spacing
                }}
              >
                <Typography
                  variant="body1"
                  sx={{
                    fontWeight: 'bold',
                    color: 'text.primary', // use theme-based text color
                  }}
                >
                  {translate('common.enable_org_level_posts', 'Enable Org Level Posts')}
                </Typography>
                <StyledComponent.SwitchIcon size="small" checked={isOrgEvent} onChange={handleOrgConnectedProfiles} />
              </Box>
            )}
            <Card>
              <DraftsPostGrid
                draftList={draftList}
                orderBy={orderBy}
                order={order}
                isOrgEvent={isOrgEvent}
                handleReCallDraft={handleReCallDraft}
                isShowOfferBanner={isShowOfferBanner}
              />
            </Card>
          </>
        )}
      </Box>
    </>
  );
};

export default Draft;
